export default __webpack_public_path__ + "static/media/DSC02217.de59938e.jpeg";